module.exports = __webpack_public_path__ + "static/11-462c319c9be67bfdd9093173201aa4ba.jpg";